module.exports = __webpack_public_path__ + "img/rachina.75527e28.jpg";